import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class LoggerService {
  public static readonly LogLevel = {
    None: 0,
    Info: 1,
    Verbose: 2,
    Warn: 3,
    Error: 4,
  };
  constructor() {}
  public info(...msg: any[]): void {
    this.logByLevel(LoggerService.LogLevel.Info, ...msg);
  }
  public error(...msg: any[]): void {
    this.logByLevel(LoggerService.LogLevel.Error, ...msg);
  }
  public warn(...msg: any[]): void {
    this.logByLevel(LoggerService.LogLevel.Warn, ...msg);
  }
  public verbose(...msg: any[]): void {
    this.logByLevel(LoggerService.LogLevel.Verbose, ...msg);
  }
  public log(...msg: any[]): void {
    if (this.checkIfError(...msg)) {
      return this.logByLevel(LoggerService.LogLevel.Error, ...msg);
    }
    this.logByLevel(LoggerService.LogLevel.None, ...msg);
  }

  private checkIfError(...msg: any[]): boolean {
    return Object.prototype.toString.call(msg[0] || {}) === "[object Error]";
  }
  private shouldDisplayOnConsole(level: any): boolean {
    if (environment.name === "production") {
      return level <= LoggerService.LogLevel.Error;
    }
    return true;
  }

  private logByLevel(level: any, ...msg: any[]): void {
    if (!this.shouldDisplayOnConsole(level)) {
      return;
    }

    switch (level) {
      case LoggerService.LogLevel.None:
        // tslint:disable-next-line:no-console
        return console["log"](...msg);
      case LoggerService.LogLevel.Info:
        // tslint:disable-next-line:no-console
        return console.info(...msg);
      case LoggerService.LogLevel.Warn:
        // tslint:disable-next-line:no-console
        return console.warn(...msg);
      case LoggerService.LogLevel.Error:
        // tslint:disable-next-line:no-console
        return console.error(...msg);
      default:
        return console["log"](msg);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/logger/logger.service.ts